<template>
  <div id="footer" class="acea-row row-middle">
    <router-link
      style="height: 100%;"
      :to="item.url"
      class="item am-cf"
      :class="{ on: item.url == $route.path }"
      v-for="(item, index) in footerList"
      :key="index"
    >
      <img
        v-if="index == 2"
        style="width: 55px;height: 55px;position: relative;top:-18px;"
        :src="item.icon1"
      />
      <div
        class="iconfont"
        v-else
        style="padding:0; height: 0.6rem !important; display:flex;align-items:center;justify-content:center;width: 100%;"
      >
        <img
          style="height: auto;width:0.7rem ;"
          v-if="item.url == $route.path"
          :src="item.icon1"
        />
        <img
          style="height: auto;width:0.6rem ;"
          v-if="item.url != $route.path"
          :src="item.icon2"
        />
      </div>
      <div v-if="index != 2" style="line-height:0.4rem;height:0.4rem;">
        {{ item.name }}
      </div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: "Footer",
  props: {},
  data: function() {
    return {
      footerList: [
        {
          name: "首页",
          icon1: require("@/assets/images/img/img/icon_home_y.png"),
          icon2: require("@/assets/images/img/img/icon_home_y.png"),
          url: "/"
        },
        {
          name: "项目",
          icon1: require("@/assets/images/img/img/icon_zx_y.png"),
          icon2: require("@/assets/images/img/img/icon_zx_y.png"),
          url: "/category"
        },
        {
          name: "资讯",
          icon1: require("@/assets/images/img/img/rijin.png"),
          icon2: require("@/assets/images/img/img/rijin.png"),
          url: "/customerService"
        },
        {
          name: "资讯",
          icon1: require("@/assets/images/img/img/kefu_icon_kf.png"),
          icon2: require("@/assets/images/img/img/kefu_icon_kf.png"),
          url: "/article"
        },
        {
          name: "我的",
          icon1: require("@/assets/images/img/img/icon_wode_y.png"),
          icon2: require("@/assets/images/img/img/icon_wode_y.png"),
          url: "/user"
        }
      ]
    };
  },
  methods: {}
};
</script>
<style type="text/css">
.iconfont {
  width: 0.6rem;
  height: 0.6rem !important;
  line-height: 0.55rem !important;
  padding: 2px;
  margin: 0 auto;
}
.iconfont img {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
